import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Navbar from "../../../Components/Navbar";
import PersnalSc from "./index.sc";
import { useForm } from "react-hook-form";
import { addDetailsOfEmployee } from "../../../api/HRDashboard/createDetails";
import { useAuthContext } from "../../../hooks";
import { getOrgUserDetails } from "../../../api/users/getOrgUserDetails";
import { getIndEmployeeDetails } from "../../../api/Payslip/getIndividualEMployeeDetails";
function Index() {
  const [userDetails ,setUserDetails] = useState<any>([])

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues:{
     dob:userDetails?.[0]?.dob,
     doj:userDetails?.[0]?.doj,
     p_email:userDetails?.[0]?.p_email,
     passport_no:userDetails?.[0]?.passport_no,
     linkedin:userDetails?.[0]?.linkedin,
     facebook:userDetails?.[0]?.facebook,
     github:userDetails?.[0]?.github,
     acc_number:userDetails?.[0]?.acc_number,
     pan_no:userDetails?.[0]?.pan_no,
     aadhar_no:userDetails?.[0]?.aadhar_no
    }
  });
  const [user, setUser] = useState<any>([]);
  const auth = useAuthContext();
  const fetchOrgUser = async () => {
    setUser(
      await getOrgUserDetails(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString()
      )
    );
    console.log("works");
  };
  const handleCreateEmployeeDetails = async (e: any) => {
    console.debug("data > ", e);
    await addDetailsOfEmployee(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0],
      {
        ...e,
        name:`${auth?.userInfo?.first_name} ${auth?.userInfo?.last_name}`
      }
    )
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
  };

  const onSubmit = async (e: any) => {
    console.log("I am Here", e);
  const res =   await handleCreateEmployeeDetails(e);
    reset();
   await  fetchUserDetails()
  };
const [loading,setIsLoading] = useState(false)
  const fetchUserDetails =async () => {
    const res = await getIndEmployeeDetails(auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs?.[0]?.employee_id
      )
      setUserDetails(res)
  }

  useEffect(() => {
    fetchOrgUser()
 fetchUserDetails()
    
  }, [auth])
console.log(auth?.userInfo)
  return (
    <>
      <PersnalSc>
        <form className="form-details" onSubmit={handleSubmit(onSubmit)}>
          <div className="inner-container">
            <label>Personal Details:</label>
            <div className="personal-detail">
              <div className="inner-content">
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Employee Id</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Employee Id"
                    defaultValue={user?.[0]?.employee_id}
                    style={{ padding: "0.8rem .75rem" }}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="name"
                    defaultValue={userDetails?.[0]?.Name ? userDetails?.[0]?.Name:`${auth?.userInfo?.first_name} ${auth?.userInfo?.last_name}`}
                    style={{ padding: "0.8rem .75rem" }}
                  />
                </Form.Group>
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Date Of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Enter date"
                    defaultValue={userDetails?.[0]?.dob}
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("dob", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group>
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Personal Email</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter personal email"
                    defaultValue={userDetails?.[0]?.p_mail}
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("p_email", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group>
              </div>
              <div className="inner-content">
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>PassPort Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your passport number"
                    defaultValue={userDetails?.[0]?.passport_no }
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("passport_no", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group>
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Linked In</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your linkedin Id"
                    defaultValue={userDetails?.[0]?.linkedin }
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("linkedin", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group>
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Facebook</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter facebook Id"
                    defaultValue={userDetails?.[0]?.facebook}
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("facebook", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group>
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Github</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Git Hub "
                    defaultValue={userDetails?.[0]?.github }
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("github", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group>
              </div>
            </div>
            <label>Accout Details:</label>
            <div className="account-details">
              <div className="inner-content">
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Account Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Account Number"
                    defaultValue={userDetails?.[0]?.acc_no}
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("acc_number", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group>
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>PAN Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter pan number"
                    defaultValue={userDetails?.[0]?.pan_no}
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("pan_no", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group>
                <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Aadhar Card Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Aadhar Card Number"
                    defaultValue={userDetails?.[0]?.aadhar_no }
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("aadhar_no", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group>
              </div>
              <div className="inner-content">
                {/* <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Nominees name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter nominess name"
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("aadhar_no", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group> */}
                {/* <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Nominees Relationship</Form.Label>
                  <Form.Select>
                    <option>Choose an option...</option>
                    <option>Father</option>
                    <option>Mother</option>
                    <option>Wife</option>
                    <option>Husband</option>
                  </Form.Select>
                </Form.Group> */}
                {/* <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Nominees proof details </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter nominess proof type"
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("aadhar_no", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group> */}
                {/* <Form.Group className="w-200 " controlId="formBasicEmail">
                  <Form.Label>Nominees proof number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter nominess name"
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("aadhar_no", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group> */}
              </div>
            </div>
            <label>Official details:</label>
            <div className="official-details">
              <Form.Group className="w-200 " controlId="formBasicEmail">
                <Form.Label>insytix Email Id</Form.Label>
                <Form.Control
                  type="text"
                  defaultValue={user?.[0]?.email}
                  placeholder="Enter Insytix Email Id"
                  style={{ padding: "0.8rem .75rem" }}
               disabled
                />
              </Form.Group>
              <Form.Group className="w-200 " controlId="formBasicEmail">
                <Form.Label>Date of join</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter your join date "
                  defaultValue={userDetails?.[0]?.doj}
                  style={{ padding: "0.8rem .75rem" }}
                  {...register("doj", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                />
              </Form.Group>
              {/* <Form.Group className="w-200 " controlId="formBasicEmail">
                <Form.Label>System model</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter system model"
                  style={{ padding: "0.8rem .75rem" }}
                  {...register("company_mail", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                />
              </Form.Group> */}
              {/* <Form.Group className="w-200 " controlId="formBasicEmail">
                <Form.Label>System model number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter system model number"
                  style={{ padding: "0.8rem .75rem" }}
                  {...register("company_mail", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                />
              </Form.Group> */}
            </div>
          </div>
          <div className="buttons-class">
            <Button className="review-button">Review</Button>
            <Button className="submit-button" type="submit">
              Submit
            </Button>
          </div>
        </form>
      </PersnalSc>
    </>
  );
}

export default Index;
